import React from 'react';
import { motion } from 'framer-motion';
import { RefreshCw } from 'lucide-react';
export function PainSection() {
  return <section className="bg-[#FAF7F2] py-20 px-4 border-t border-[#e5e0d8]" data-id="element-148">
      <div className="max-w-2xl mx-auto" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-150">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-8 text-center" data-id="element-151">
            Esto es lo que pasa
            <br data-id="element-152" />
            <span className="text-xl md:text-2xl font-normal text-gray-600" data-id="element-153">
              (aunque nadie lo diga)
            </span>
          </h2>

          <div className="prose prose-lg prose-p:text-[#2D2A26] prose-p:text-lg md:prose-p:text-xl prose-p:leading-relaxed mb-12" data-id="element-154">
            <p data-id="element-155">Llegas a mitad de mes y ya sientes la presión en el pecho.</p>
            <p data-id="element-156">
              No porque hayas hecho “locuras”. Sino porque el dinero se te fue…
              en fugas.
            </p>
            <p data-id="element-157">Y cuando hay fugas, todo se siente igual:</p>
          </div>

          {/* Cycle Visualization */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 mb-12 relative overflow-hidden" data-id="element-158">
            <div className="absolute top-0 left-0 w-full h-2 bg-[#C94040]" data-id="element-159"></div>

            <div className="space-y-6 relative z-10" data-id="element-160">
              {['Pagas tarde → te castigan con cargos', 'Pagas cargos → te falta para comida/medicina', 'Te falta → improvisas', 'Improvisas → vuelven las fugas'].map((item, index) => <div key={index} className="flex items-center gap-4" data-id="element-161">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#1B2A4A] text-white flex items-center justify-center font-bold text-sm" data-id="element-162">
                    {index + 1}
                  </div>
                  <p className="text-lg md:text-xl font-medium text-[#2D2A26]" data-id="element-163">
                    {item}
                  </p>
                </div>)}
            </div>

            <div className="mt-8 flex justify-center text-[#C94040]" data-id="element-164">
              <RefreshCw className="w-12 h-12 animate-spin-slow opacity-20" data-id="element-165" />
            </div>
          </div>

          <div className="text-center" data-id="element-166">
            <p className="text-xl md:text-2xl font-serif font-bold text-[#1B2A4A] leading-relaxed" data-id="element-167">
              Es una rueda.
              <br data-id="element-168" />
              Y esa rueda no se rompe con fuerza de voluntad.
              <br data-id="element-169" />
              <span className="text-[#C94040] bg-[#C94040]/10 px-2 rounded" data-id="element-170">
                Se rompe con un sistema.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}